module.exports = __webpack_public_path__ + "static/media/android_baner.9d6abc8d.png";